var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0017 8.00037H4.9984C4.447 8.00037 4 8.44736 4 8.99877V15.0021C4 15.5535 4.447 16.0005 4.9984 16.0005H11.0017C11.5531 16.0005 12.0001 15.5535 12.0001 15.0021V8.99877C12.0001 8.44736 11.5531 8.00037 11.0017 8.00037Z",
    stroke: "#100A12",
    strokeWidth: 1.3,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.00098 6.28625V4.9984C8.00098 4.44694 8.44792 4 8.99938 4H15.0027C15.5542 4 16.0011 4.44694 16.0011 4.9984V11.0017C16.0011 11.5532 15.5542 12.0001 15.0027 12.0001H13.7149",
    stroke: "#100A12",
    strokeWidth: 1.3,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyIcon);
export default __webpack_public_path__ + "static/media/copy-icon.7932181ce681909f9afc8509c3a3e99f.svg";
export { ForwardRef as ReactComponent };